// extracted by mini-css-extract-plugin
export default {"root":"style_root__BKcUI","blink-animation":"style_blink-animation__7Ghbs"};